import React from 'react';

import { Button as ChakraButton, ButtonProps as ChakraButtonProps } from '@chakra-ui/react';

// see https://github.com/total-typescript/react-typescript-tutorial/blob/main/src/08-advanced-patterns/72-as-prop-with-forward-ref.solution.tsx#L12

type FixedForwardRef = <T, P = {}>(
	render: (props: P, ref: React.Ref<T>) => React.ReactNode,
) => (props: P & React.RefAttributes<T>) => React.ReactNode;

const fixedForwardRef = React.forwardRef as FixedForwardRef;

type DistributiveOmit<T, TOmitted extends PropertyKey> = T extends any ? Omit<T, TOmitted> : never;

const UnwrappedButton = <TAs extends React.ElementType = typeof ChakraButton>(
	props: {
		as?: TAs;
	} & DistributiveOmit<React.ComponentPropsWithRef<TAs>, 'as'> &
		ChakraButtonProps,
	ref: React.ForwardedRef<any>,
) => {
	const { type = 'button', colorScheme = 'primary', children, ...rest } = props;
	const isLink = (props as any).to !== undefined;

	return (
		<ChakraButton
			colorScheme={colorScheme}
			type={isLink ? undefined : type}
			py={0}
			px={6}
			fontWeight="bold"
			ref={ref}
			{...rest}
		>
			{children}
		</ChakraButton>
	);
};

export const Button = fixedForwardRef(UnwrappedButton);
